import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, TablePagination, Typography,
} from '@mui/material';
import * as C from '../../../theme/colors.constants';
import TableTitulosProcesso from './TableTitulosProcesso';
import { OPCOES_TAMANHO_PAGINA_TITULOS } from './titulosController';

/**
 * Pop-up "Expandir Títulos" (`fullScreen`, diferente de `DialogExpandirHistorico`
 * — usuário pediu explicitamente "ocupando a tela toda") — mesmo `titulos`
 * já carregado/paginado/ordenado pelo container (sem fetch novo), somente
 * leitura.
 *
 * **Dupla barreira contra mutação dentro do pop-up** (mesmo padrão de
 * `DialogExpandirHistorico.jsx`): não aceita `onEditarTitulo`/`onExcluirTitulo`
 * na própria assinatura de props — hardcoda `NAO_OPERAR` local +
 * `disabledGerenciarTitulos`/`cannotEnabled` fixos em `true`, não repassa a
 * mutação real da aba mesmo que o chamador a tenha disponível.
 *
 * MUI `Dialog` já desmonta os filhos ao fechar por padrão (sem `keepMounted`)
 * e o componente não guarda nenhum estado/fetch próprio — mesmo critério já
 * documentado para `DialogExpandirHistorico.jsx`: não precisa dos guards de
 * sessão/`idProcessoRef` usados por dialogs que buscam dado sozinhos.
 */
const NAO_OPERAR = () => {};

export default function DialogExpandirTitulos({
  open, onClose, titulos, titulosTotal, titulosPagina, titulosTamanhoPagina, titulosOrdenacao,
  onChangeOrdenacaoTitulos, onChangePaginaTitulos, onChangeTamanhoPaginaTitulos,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle>Títulos do processo</DialogTitle>
      <DialogContent>
        {titulos?.length ? (
          <Box sx={{ overflowX: 'auto' }}>
            <TableTitulosProcesso
              titulos={titulos}
              ordenacao={titulosOrdenacao}
              onChangeOrdenacao={onChangeOrdenacaoTitulos}
              disabledGerenciarTitulos
              cannotEnabled
              onEditarTitulo={NAO_OPERAR}
              onExcluirTitulo={NAO_OPERAR}
            />
          </Box>
        ) : (
          <Typography variant="body2" sx={{ color: C.warmGrey, textAlign: 'center', py: 3 }}>
            {titulos == null ? 'Carregando...' : 'Não foram encontrados Títulos para este Processo.'}
          </Typography>
        )}
        {titulosTotal > 0 && (
          <TablePagination
            component="div"
            count={titulosTotal}
            page={titulosPagina}
            rowsPerPage={titulosTamanhoPagina}
            rowsPerPageOptions={OPCOES_TAMANHO_PAGINA_TITULOS}
            onPageChange={(event, novaPagina) => onChangePaginaTitulos(novaPagina)}
            onRowsPerPageChange={onChangeTamanhoPaginaTitulos}
            labelRowsPerPage="Linhas por página:"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
}
DialogExpandirTitulos.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  titulos: PropTypes.array,
  titulosTotal: PropTypes.number,
  titulosPagina: PropTypes.number,
  titulosTamanhoPagina: PropTypes.number,
  titulosOrdenacao: PropTypes.shape({
    campo: PropTypes.string,
    direcao: PropTypes.oneOf(['ASC', 'DESC']),
  }),
  onChangeOrdenacaoTitulos: PropTypes.func,
  onChangePaginaTitulos: PropTypes.func.isRequired,
  onChangeTamanhoPaginaTitulos: PropTypes.func.isRequired,
};
DialogExpandirTitulos.defaultProps = {
  open: false,
  titulos: [],
  titulosTotal: 0,
  titulosPagina: 0,
  titulosTamanhoPagina: 10,
  titulosOrdenacao: { campo: 'dataVencimento', direcao: 'ASC' },
  onChangeOrdenacaoTitulos: null,
};
